import { render, staticRenderFns } from "./ComprasProdutosPreco.vue?vue&type=template&id=72703fe0&"
import script from "./ComprasProdutosPreco.vue?vue&type=script&lang=js&"
export * from "./ComprasProdutosPreco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports